export const initialState = {
  touchPoints: [],
  auditTouchPoints: null,
  touchPoint: null,
};

export const touchPoints = (state = initialState) => state.touchPoints || initialState.touchPoints;
export const touchPoint = (state = initialState) => state.touchPoint || initialState.touchPoint;

export const mapCommentsLikes = ({ comments = [], commentLikes = [], loggedUser }) => {
  return comments.map(comment => {
    comment.likes = [];
    commentLikes.forEach(like => {
      if (like.commentId === comment._id) {
        comment.likes = [...comment.likes, like];
        if (like.userId && like.userId._id === loggedUser) {
          comment.wasLiked = true;
        }
      }
    });
    return comment;
  });
};
